import { colors, fonts } from '@grupoboticario/flora-tokens/blzPro/web/ds'

export const blzPro = {
  colors,
  fonts,
}
